import { defineMessages } from 'react-intl';

import { chatbotMessages, chatbotPromptMessages } from '../Chatbot/messages';

const messages = defineMessages({
  backgroundColor: {
    id: 'Chatbot home background color',
    defaultMessage: 'Color de fons',
  },
  block: {
    id: 'Chatbot Home',
    defaultMessage: 'Chatbot Home',
  },
  defaultFieldset: {
    id: 'Chatbot home default fieldset',
    defaultMessage: 'Default',
  },
  description: {
    id: 'Chatbot home description',
    defaultMessage: 'Descripció',
  },
  darkColor: {
    id: 'Chatbot home color dark',
    defaultMessage: 'Dark',
  },
  defaultColor: {
    id: 'Chatbot home color default',
    defaultMessage: 'Default',
  },
  placeholder: {
    id: 'Chatbot home placeholder',
    defaultMessage: 'Placeholder',
  },
  primaryColor: {
    id: 'Chatbot home color primary',
    defaultMessage: 'Primary (Iskra black + yellow accent)',
  },
  suggestionText: {
    id: 'Chatbot home suggestion text',
    defaultMessage: 'Text',
  },
  suggestions: {
    id: 'Chatbot home suggestions',
    defaultMessage: 'Suggeriments',
  },
  title: {
    id: 'Chatbot home title',
    defaultMessage: 'Títol',
  },
});

const getMessage = (intl, descriptor) => (intl ? intl.formatMessage(descriptor) : descriptor.defaultMessage);

const getDefaultSuggestions = (intl) =>
  chatbotPromptMessages.map((descriptor, index) => ({
    '@id': `suggestion-${index + 1}`,
    text: getMessage(intl, descriptor),
  }));

export const ChatbotHomeSchema = ({ intl } = {}) => ({
  title: getMessage(intl, messages.block),
  fieldsets: [
    {
      id: 'default',
      title: getMessage(intl, messages.defaultFieldset),
      fields: ['title', 'description', 'placeholder', 'suggestions', 'color'],
    },
  ],
  properties: {
    title: {
      title: getMessage(intl, messages.title),
      default: getMessage(intl, chatbotMessages.defaultHomeTitle),
    },
    description: {
      title: getMessage(intl, messages.description),
      default: getMessage(intl, chatbotMessages.defaultHomeDescription),
    },
    placeholder: {
      title: getMessage(intl, messages.placeholder),
      default: getMessage(intl, chatbotMessages.defaultHomePlaceholder),
    },
    suggestions: {
      title: getMessage(intl, messages.suggestions),
      widget: 'object_list',
      schema: {
        title: getMessage(intl, messages.suggestions),
        fieldsets: [
          {
            id: 'default',
            title: getMessage(intl, messages.defaultFieldset),
            fields: ['text'],
          },
        ],
        properties: {
          text: {
            title: getMessage(intl, messages.suggestionText),
          },
        },
        required: ['text'],
      },
      default: getDefaultSuggestions(intl),
    },
    color: {
      title: getMessage(intl, messages.backgroundColor),
      choices: [
        ['default', getMessage(intl, messages.defaultColor)],
        ['primary', getMessage(intl, messages.primaryColor)],
        ['dark', getMessage(intl, messages.darkColor)],
      ],
      default: 'primary',
    },
  },
  required: ['title'],
});

export default ChatbotHomeSchema;
